<template>
  <div class="payList" :style="payListStyle">
    <avue-crud :option="option"
               :data="list"
               :page="page"
               :row-style="rowStyle"
               :cell-style="cellStyle"
               @current-change="currentChange"
               @search-change="searchChange"
               @search-reset="refreshChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange">
      <template slot="header">
        <avue-data-box :option="dataOption"/>
      </template>
      <template slot="menuLeft">
        <el-button type="danger"
                   icon="el-icon-document"
                   @click="$router.push({path:'/fp'})"
                   size="mini">授权管理
        </el-button>
        <el-button type="primary"
                   icon="el-icon-user"
                   @click="$router.push({path:'/sf'})"
                   size="mini">实名管理
        </el-button>
        <el-button type="primary"
                   icon="el-icon-document-copy"
                   @click="$router.push({path:'/log'})"
                   size="mini">日志管理
        </el-button>
        <el-button type="success"
                   icon="el-icon-data-line"
                   @click="$router.push({path:'/user/product'})"
                   size="mini">插件管理
        </el-button>
        <el-button type="primary"
                   icon="el-icon-refresh"
                   @click="handleTime"
                   size="mini">{{ time === 0 ? '刷 新' : '停 止' }}
        </el-button>
      </template>
      <template slot-scope="scope" slot="type">
        <img width="30"
             :src="scope.row.type === 0 ? '/images/zfbicon.png' : (scope.row.type === 1 ? '/images/wxicon.png' : '/images/zgyhicon.png')">
      </template>
      <template slot="menu"
                slot-scope="scope">
        <template v-if="!scope.row.flag">
          <el-button type="text"
                     @click="handleOk(scope.row)"
                     size="small">开通
          </el-button>
          <el-button type="text"
                     @click="handleDel(scope.row)"
                     size="small">删除
          </el-button>
          <el-button type="text"
                     @click="handlePrice(scope.row)"
                     size="small">改价
          </el-button>
        </template>
        <template v-else>
          <el-button type="text"
                     @click="handleReset(scope.row)"
                     size="small">重置
          </el-button>
        </template>
        <!--        <el-button type="text"
                           @click="handleBind(scope.row)"
                           size="small">改绑
                </el-button>-->
        <el-button type="text" v-if="scope.row.version!==0"
                   @click="handleFp(scope.row)"
                   size="small">发票
        </el-button>
        <el-button type="text" v-if="scope.row.version===3||scope.row.version===5||scope.row.version===8"
                   @click="handlePush(scope.row)"
                   size="small">推送
        </el-button>
        <el-button type="text" v-if="scope.row.version===3"
                   @click="handlePushAvue(scope.row)"
                   size="small">开通Avue
        </el-button>
        <el-button type="text" v-if="scope.row.version===5"
                   @click="handlePushAvueData(scope.row)"
                   size="small">开通Data
        </el-button>
        <el-button type="text" v-if="scope.row.version===8"
                   @click="handlePushAvueAI(scope.row)"
                   size="small">开通AI
        </el-button>
      </template>
    </avue-crud>
    <el-dialog title="发票信息"
               top="40px"
               :before-close="beforeClose"
               :visible.sync="fpbox"
               width="500px">
      <avue-form ref="fpform" :option="fpoption"
                 @submit="fpSubmit"
                 v-model="fpform">
        <template slot="compid"
                  slot-scope="{}">
          <el-input placeholder="请输入编号"
                    v-model="fpform.compid">
            <div slot="append" style="cursor: pointer"
                 @click="buildId">自动生成编号
            </div>
          </el-input>
        </template>
        <template slot="menuForm">
          <el-button @click="fpBuild">生成授权书</el-button>
        </template>
      </avue-form>
    </el-dialog>
    <auth ref="auth"
          @submit="getList">
    </auth>
  </div>
</template>

<script>
import {config, payList} from '../const/config'
import {mapState} from 'vuex';
import Record from '@/util/record';
import {validatenull} from '@/util/validate';

export default {
  data() {
    return {
      account: '',
      qq: '',
      sliderVisible: true, // 控制slider的显示
      moneyData: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSizes: [10, 30, 50, 100, 200, 1000],
        pageSize: 10
      },
      check: 0,
      flag: false,
      time: 0,
      fpbox: false,
      version: 0,
      fpform: {
        qq: ''
      },
      fpoption: {
        size: 'mini',
        emptyBtn: false,
        column: [
          {
            label: '订单号',
            prop: 'orderid',
            span: 24
          }, {
            label: '编号',
            prop: 'compid',
            formslot: true,
            span: 24
          }, {
            label: '开票金额',
            prop: 'money',
            rules: [{
              required: true,
              message: "请输入开票金额",
              trigger: "blur"
            }],
            span: 24
          }, {
            label: '展示名称',
            prop: 'zsmc',
            rules: [{
              required: true,
              message: "请输入展示名称",
              trigger: "blur"
            }],
            span: 24
          }, {
            label: '公司名称',
            prop: 'mc',
            rules: [{
              required: true,
              message: "请输入公司名称",
              trigger: "blur"
            }],
            span: 24
          }, {
            label: '公司税号',
            prop: 'sh',
            rules: [{
              required: true,
              message: "请输入公司税号",
              trigger: "blur"
            }],
            span: 24
          }
          /*, {
            label: '收件人',
            prop: 'sjr',
            span: 24
          }, {
            label: '联系方式',
            prop: 'lxfs',
            span: 24
          }, {
            label: '收件地址',
            prop: 'sjdz',
            type: 'textarea',
            span: 24
          }*/
          , {
            label: '备注',
            prop: 'bz',
            span: 24
          }]
      },
      option: {
        size: 'mini',
        excelBtn: true,
        selection: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        index: true,
        tip: false,
        headerAlign: 'center',
        menuAlign: 'left',
        align: 'center',
        menuWidth: 260,
        sumColumnList: [
          {
            name: 'money',
            type: 'sum'
          },
          {
            name: 'version',
            type: 'count'
          }
        ],
        defaultSort: {
          prop: 'datetime',
          order: 'descending'
        },
        column: [
          {
            width: 200,
            label: '订单号',
            prop: 'orderid',
            search: true
          }, {
            label: '授权名',
            prop: 'version',
            type: 'select',
            dicData: config,
            filter: true,
          }, {
            label: '金额',
            prop: 'money'
          }, {
            label: '授权账号',
            prop: 'qq',
            search: true
          }, {
            label: '支付类型',
            prop: 'type',
            type: 'select',
            dicData: payList,
            filter: true,
            slot: true,
          }, {
            label: '状态',
            prop: 'flag',
            type: 'select',
            filter: true,
            dicData: [{
              label: '已付款',
              value: true
            }, {
              label: '未确认',
              value: false
            }]
          }, {
            label: '下单日期',
            sortable: true,
            prop: 'datetime',
          }
        ]
      },
      list: [],
    }
  },
  computed: {
    payListStyle() {
      // 根据 sliderVisible 状态返回不同的 padding
      return this.sliderVisible
        ? {padding: '100px 10px 100px 10px'} // 默认 padding
        : {padding: '200px 10px 100px 10px'}; // slider 隐藏时的 padding
    },
    dataOption() {
      return {
        span: 4,
        data: [
          {
            title: '总单数',
            count: this.moneyData[0] || 0,
            icon: 'el-icon-s-check',
            color: '#00a680',
            target: '_blank'
          },
          {
            title: '总金额',
            count: this.moneyData[1] || 0,
            icon: 'el-icon-s-order',
            color: '#E6A23C',
            target: '_blank'
          }, {
            title: '上月金额',
            count: this.moneyData[2] || 0,
            icon: 'el-icon-view',
            color: 'rgb(56, 161, 242)',
            target: '_blank'
          },
          {
            title: '本月金额',
            count: this.moneyData[3] || 0,
            icon: 'el-icon-setting',
            color: 'rgb(117, 56, 199)',
            target: '_blank'
          },
          {
            title: '今日金额',
            count: this.moneyData[4] || 0,
            icon: 'el-icon-tickets',
            color: '#F56C6C',
            target: '_blank'
          },
          {
            title: '今日单数',
            count: this.moneyData[5] || 0,
            icon: 'el-icon-user',
            color: 'rgb(97, 60, 189)',
            target: '_blank'
          },
        ]
      }
    },
    ...mapState(['pwd', 'user', 'token']),
  },
  created() {
    const handleResize = () => {
      this.sliderVisible = window.innerWidth > 768;
    };
    handleResize(); // 确保首次加载时执行
    window.addEventListener('resize', () => {
      this.sliderVisible = window.innerWidth > 768;
      this.$forceUpdate(); // 强制更新视图
    });
  },
  methods: {
    buildId() {
      const query = new Record('x_ticket');
      query.equalTo("compid", " is not ", 'null');
      query.order("-compid");
      query.limit(1)
      query.find().then(res => {
        const key = 'BLADE-', len = 6;
        let id = Number(res.data[0].compid.replace(/[^0-9]/ig, "")) + 1;
        let length = len - (id + '').length;
        let result = '';
        for (let i = 0; i < length; i++) {
          result = result + '0'
        }
        result = key + result + id;
        this.fpform.compid = result;
        this.$message.success('生成成功')
      });
    },
    getMoneyData() {
      let query = new Record('x_order');
      const date = new Date();

      let month = date.getMonth() + 1;
      //month = month < 10 ? '0' + month : month
      let lastmonth = date.getMonth();
      //lastmonth = lastmonth < 10 ? '0' + lastmonth : lastmonth
      let year = date.getFullYear();
      let lastyear = year;
      if (lastmonth === 0) {
        lastyear = year - 1;
        lastmonth = 12;
      }

      const thisDay1 = new Date(year, month - 1, 1).Format('yyyy-MM-dd');
      const thisDay2 = new Date(year, month, 0).Format('yyyy-MM-dd');
      const lastDay1 = new Date(lastyear, lastmonth - 1, 1).Format('yyyy-MM-dd');
      const lastDay2 = new Date(lastyear, lastmonth, 0).Format('yyyy-MM-dd');

      //总订单
      query = new Record('x_order');
      query.equalTo("flag", "=", true);
      query.count().then(res => {
        this.$set(this.moneyData, 0, res.data)
      })
      // 总金额
      query.equalTo("flag", "=", true);
      query.sumTo("money");
      query.find().then(res => {
        this.$set(this.moneyData, 1, res.data[0].total)
      });
      //上月金额
      query = new Record('x_order');
      query.equalTo("datetime", ">=", `'${lastDay1} 00:00:00'`);
      query.equalTo("datetime", "<=", `'${lastDay2} 23:59:59'`);
      query.equalTo("flag", "=", true);
      query.sumTo("money");
      query.find().then(res => {
        this.$set(this.moneyData, 2, res.data[0].total)
      });
      //本月金额
      query = new Record('x_order');
      query.equalTo("datetime", ">=", `'${thisDay1} 00:00:00'`);
      query.equalTo("datetime", "<=", `'${thisDay2} 23:59:59'`);
      query.equalTo("flag", "=", true);
      query.sumTo("money");
      query.find().then(res => {
        this.$set(this.moneyData, 3, res.data[0].total)
      });
      //今日金额
      query = new Record('x_order');
      query.equalTo("datetime", ">=", `'${(new Date()).Format('yyyy-MM-dd')}'`);
      query.equalTo("flag", "=", true);
      query.sumTo("money");
      query.find().then(res => {
        this.$set(this.moneyData, 4, res.data[0].total)
      });
      //今日订单
      query = new Record('x_order');
      query.equalTo("flag", "=", true);
      query.equalTo("datetime", ">=", `'${(new Date()).Format('yyyy-MM-dd')}'`);
      query.countTo("money");
      query.find().then(res => {
        this.$set(this.moneyData, 5, res.data[0].total)
      })
    },
    currentChange(val) {
      this.page.currentPage = val;
      this.getList()
    },
    searchChange(params) {
      this.getList(params);
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList()
    },
    fpBuild() {
      const {href} = this.$router.resolve({
        path: '/sqs',
        query: {
          qq: this.fpform.qq,
          id: this.fpform.compid,
          name: this.fpform.mc,
          date: this.fpform.datetime
        }
      })
      window.open(href, '_blank')
    },
    beforeClose(done) {
      this.$refs.fpform.resetForm();
      done()
    },
    handleFp(row) {
      this.version = row.version;
      const query = new Record("x_ticket");
      query.equalTo("orderid", "=", `'${row.orderid}'`);
      query.find().then(res => {
        if (this.validatenull(res.data[0])) {
          delete this.fpform.objectId;
          this.fpform.compid = 'BLADE-';
          this.fpform.orderid = row.orderid;

          // 默认设置价格
          const cfg = config.filter(item => item.value === this.version)[0];
          let money = cfg.money + '';
          if (this.version === 1) {
            money = 5000;
          }
          if (this.version === 3) {
            money = 8999;
          }
          if (this.version === 5) {
            money = 5999;
          }
          if (this.version === 6) {
            if (row.money === 4900) {
              money = 6999;
            } else if (row.money === 5600) {
              money = 7999;
            } else {
              money = 0;
            }
          }

          this.fpform.money = money + '';

          this.fpform.qq = row.qq;
          this.fpform.zsmc = '';
          this.fpform.mc = '';
          this.fpform.sh = '';
          this.fpform.sjr = '';
          this.fpform.lxfs = '';
          this.fpform.sjdz = '';
          this.fpbox = true;
          this.$alert(`暂无提供发票信息`, '提示', {
            confirmButtonText: '确定',
          });
        } else {
          this.fpform = res.data[0];
          this.fpform.qq = row.qq;
          this.fpbox = true
        }

      });
    },
    handlePrice(row) {
      const confirmText = ['请修改订单金额'];
      const newDatas = [];
      const h = this.$createElement;
      for (const i in confirmText) {
        newDatas.push(h('p', null, confirmText[i]));
      }
      const that = this;
      this.$prompt('修改确认', '修改确认', {
        message: h('div', null, newDatas),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]+$/,
        inputErrorMessage: '金额格式不正确',
        inputValue: 5600
      }).then(({value}) => {
        row.money = value;
        that.update(row.objectId, {
          money: value
        })
      });
    },
    handleBind(row) {

      const confirmText = ['请修改授权QQ'];
      const newDatas = [];
      const h = this.$createElement;
      for (const i in confirmText) {
        newDatas.push(h('p', null, confirmText[i]));
      }
      const that = this;
      this.$prompt('修改确认', '修改确认', {
        message: h('div', null, newDatas),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]+$/,
        inputErrorMessage: 'QQ格式不正确',
      }).then(({value}) => {
        if (validatenull(value)) {
          this.$message.error({message: '请输入QQ号', offset: 60});
          return;
        }
        const queryTicket = new Record('x_ticket');
        queryTicket.equalTo("orderid", "=", `'${row.orderid}'`);
        queryTicket.find().then(resTicket => {
          if (!this.validatenull(resTicket.data[0])) {
            // 获取授权库数据
            const data = resTicket.data[0];

            // 更新订单表QQ
            that.update(row.objectId, {
              qq: value
            }, 'x_order');
            // 更新授权表QQ
            that.update(data.objectId, {
              qq: value
            }, 'x_ticket');
            // 插入变更记录表
            const form = {};
            form.auth = true;
            form.token = that.token;
            form.orderid = row.orderid;
            form.compid = data.compid;
            form.mc = data.mc
            form.qqold = data.qq;
            form.qqnew = value;
            this.insert(form, "x_changelog").then((res) => {
              window.console.log(res);
              row.qq = value;
              this.$message.success('改绑成功');
            });
          } else {
            this.$message.error({message: '未查询到订单信息，请手动处理', offset: 60});
          }
        });
      });
    },
    fpSubmit(form, done) {
      form = this.deepClone(this.fpform);
      if (!form.datetime) form.datetime = (new Date()).Format('yyyy.MM.dd');
      if (form.objectId) {
        form.money = form.money + '';
        delete form.flag;
        delete form.datetime;
        this.update(form.objectId, form, 'x_ticket').then(() => {
          this.fpbox = false;
          this.$message.success('发票修改成功');
          done();
        })
      } else {
        delete form.objectId;
        delete form.createdAt;
        delete form.updatedAt;
        form.flag = false;
        this.insert(form, 'x_ticket').then(() => {
          this.fpbox = false;
          this.$message.success('发票提交成功');
          done();
        })
      }
    },
    insert(data, table) {
      const query = new Record(table || 'x_order');
      const entity = {};
      Object.keys(data).forEach(ele => {
        if (ele.includes('$')) {
          entity[ele.replace('$', '') + '_text'] = data[ele];
        } else {
          if (!ele.includes("auth") && !ele.includes("token")) {
            entity[ele] = data[ele];
          } else {
            query.auth(true);
            query.username(this.user);
            query.token(this.token);
          }
        }
      })
      query.entity(entity);
      return query.save()
    },
    update(id, data, table) {
      const form = this.deepClone(data);
      const query = new Record(table || 'x_order');
      const entity = {};
      entity['id'] = id;
      delete form.createdAt;
      delete form.updatedAt;
      delete form.objectId;
      Object.keys(form).forEach(ele => {
        if (form[ele]) {
          entity[ele] = form[ele]
        }
      })
      query.entity(entity);
      return query.update()
    },
    del(row) {
      const query = new Record('x_order');
      query.remove(row.objectId);
      const queryTicket = new Record('x_ticket');
      queryTicket.equalTo("orderid", "=", `'${row.orderid}'`);
      queryTicket.find().then(res => {
        queryTicket.remove(res.data[0].objectId);
      })
    },
    rowStyle({row}) {
      if (!row.flag) {
        return {
          backgroundColor: 'rgba(245,108,108,0.1)'
        }
      }
    },
    cellStyle({row, columnIndex}) {
      if (columnIndex == 7) {
        return Object.assign((() => {
          return {color: row.type === 0 ? '#409EFF' : (row.type === 1 ? 'green' : 'red'),}
        })(), {
          fontWeight: 'bold',
          fontSize: '20'
        })

      } else if (columnIndex == 8) {
        if (!row.flag) {
          return {
            color: 'red',
            fontWeight: 'bold',
            fontSize: '20'
          }
        }
      } else if (columnIndex == 2) {
        return {
          color: '#333',
          fontWeight: 'bold',
          fontSize: '20'
        }
      }
    },
    handleDel(row) {
      this.$confirm(`是否删除<<${row.qq}>>的<<${row.name}>>订单`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return this.del(row)
      }).then(() => {
        this.list.splice(row.$index, 1);
        this.$message.success('删除成功')
      })
    },
    handleReset(row) {
      this.$confirm(`是否重置<<${row.qq}>>的<<${row.name}>>权限`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (row.version === 1) {
          // 企业版
          return this.$httpajax.get(`${this.website.GIT.url}&qq=${row.qq}&type=blade-business&token=${this.token}`)
        } else if (row.version === 3) {
          // 联合版
          return this.$httpajax.get(`${this.website.GIT.url}&qq=${row.qq}&type=blade-avue&token=${this.token}`)
        } else if (row.version === 5) {
          // 单大屏
          return this.$httpajax.get(`${this.website.GIT.url}&qq=${row.qq}&type=blade-data&token=${this.token}`)
        } else if (row.version === 6) {
          // 单物联网
          return this.$httpajax.get(`${this.website.GIT.url}&qq=${row.qq}&type=blade-iot-reset&token=${this.token}`)
        } else {
          // 专业版
          return this.$httpajax.get(`${this.website.GIT.url}&qq=${row.qq}&type=blade-code&token=${this.token}`)
        }
      }).then((res) => {
        this.$alert(`${res.data}`, '提示', {
          confirmButtonText: '确定',
        });
      })
    },
    handleOk(row) {
      this.$confirm(`是否更新<<${row.qq}>>的<<${row.name}>>权限`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.flag = true
        return this.update(row.objectId, {
          flag: true
        })
      }).then(() => {
        return this.$confirm(`是否开通<<${row.qq}>>的<<${row.name}>>权限`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      }).then(() => {
        if (row.version === 1) {
          // 企业版
          return this.$httpajax.get(`${this.website.GIT.url}&qq=${row.qq}&type=blade-business&token=${this.token}`)
        } else if (row.version === 3) {
          // 联合版
          return this.$httpajax.get(`${this.website.GIT.url}&qq=${row.qq}&type=blade-avue&token=${this.token}`)
        } else if (row.version === 5) {
          // 单大屏
          return this.$httpajax.get(`${this.website.GIT.url}&qq=${row.qq}&type=blade-data&token=${this.token}`)
        } else if (row.version === 6) {
          // 单物联网
          return this.$httpajax.get(`${this.website.GIT.url}&qq=${row.qq}&type=blade-iot&token=${this.token}`)
        } else if (row.version === 8) {
          // 单大模型
          return this.$httpajax.get(`${this.website.GIT.url}&qq=${row.qq}&type=blade-ai&token=${this.token}`)
        } else {
          // 专业版
          return this.$httpajax.get(`${this.website.GIT.url}&qq=${row.qq}&type=blade-code&token=${this.token}`)
        }
      }).then((res) => {
        const data = res.data;
        if (row.qq.indexOf('@') !== -1) {
          this.account = data.split(' 注册成功')[0];
          this.qq = row.qq;
          window.console.log(`账号已开通： + <<${this.account}>> <<${this.qq}>>`);
        }
        this.$alert(`${data}`, '提示', {
          confirmButtonText: '确定',
        });
      })
    },
    handlePush(row) {
      this.$confirm(`是否推送<<${row.qq}>>的<<${row.name}>>信息至avue系统`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.version = row.version;
        const query = new Record('x_ticket');
        query.equalTo("orderid", "=", `'${row.orderid}'`);
        query.find().then(res => {
          if (this.validatenull(res.data[0])) {
            this.$alert(`暂无发票信息，无法推送`, '提示', {
              confirmButtonText: '确定',
            });
          } else {
            this.fpform = res.data[0];
            this.fpform.qq = row.qq;
            // 推送avue订单信息
            let data = this.deepClone(row);
            data.flag = true;
            delete data.objectId;
            delete data.createdAt;
            delete data.updatedAt;
            let avueMoney;
            let avueVersion;
            if (this.version === 5) {
              avueMoney = 3156;
              avueVersion = 6;
            } else if (this.version === 3 && (this.fpform.bz.indexOf("物联网") > 0 || this.fpform.bz.indexOf("3156") > 0 || this.fpform.bz.indexOf("打折") > 0)) {
              avueMoney = 3156;
              avueVersion = 10;
            } else if (this.version === 8) {
              avueMoney = row.money;
              avueVersion = 20;
            } else {
              avueMoney = 3655;
              avueVersion = 10;
            }
            this.$httpajax.post('https://api.avuejs.com/sysdata?type=0', Object.assign(data, {
              money: avueMoney,
              version: avueVersion
            }));
            // 推送avue发票信息
            this.fpform.flag = true;
            this.fpform.datetime = new Date(this.fpform.datetime).Format("yyyy.MM.dd");
            delete this.fpform.compid;
            delete this.fpform.zsmc;
            delete this.fpform.money;
            delete this.fpform.objectId;
            delete this.fpform.createdAt;
            delete this.fpform.updatedAt;
            delete this.fpform.bz;
            delete this.fpform.sjr;
            delete this.fpform.lxfs;
            delete this.fpform.sjdz;
            this.$httpajax.post('https://api.avuejs.com/sysdata?type=1', this.fpform);
            this.dingPush(row);
          }
        });
      })
    },
    handlePushAvue(row) {
      let username = row.qq;
      let url = `${this.website.GIT.avueUrl}&qq=${row.qq}&key=${this.website.GIT.avueKey}`;
      if (row.qq.indexOf('@') !== -1 && !validatenull(this.account) && row.qq === this.qq) {
        username = this.account;
        url += `&account=${this.account}`;
      }
      this.$confirm(`是否开通<<${row.qq}>>的<<${row.name}>>Avue权限，账号<<${username}>>`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$httpajax.post(url).then((res) => {
          this.$alert(`${res.data.msg}`, '提示', {
            confirmButtonText: '确定',
          });
        });
      })
    },
    handlePushAvueData(row) {
      let username = row.qq;
      let url = `${this.website.GIT.avueDataUrl}&qq=${row.qq}&key=${this.website.GIT.avueKey}`;
      if (row.qq.indexOf('@') !== -1 && !validatenull(this.account) && row.qq === this.qq) {
        username = this.account;
        url += `&account=${this.account}`;
      }
      this.$confirm(`是否开通<<${row.qq}>>的<<${row.name}>>AvueData权限，账号<<${username}>>`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$httpajax.post(url).then((res) => {
          this.$alert(`${res.data.msg}`, '提示', {
            confirmButtonText: '确定',
          });
        });
      })
    },
    handlePushAvueAI(row) {
      let username = row.qq;
      let url = `${this.website.GIT.avueAIUrl}&qq=${row.qq}&key=${this.website.GIT.avueKey}`;
      if (row.qq.indexOf('@') !== -1 && !validatenull(this.account) && row.qq === this.qq) {
        username = this.account;
        url += `&account=${this.account}`;
      }
      this.$confirm(`是否开通<<${row.qq}>>的<<${row.name}>>AvueAI权限，账号<<${username}>>`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$httpajax.post(url).then((res) => {
          this.$alert(`${res.data.msg}`, '提示', {
            confirmButtonText: '确定',
          });
        });
      })
    },
    handleTime() {
      if (this.time == 0) {
        this.time = 1000;
        this.check = setInterval(() => {
          this.getList()
        }, this.time);

      } else {
        this.time = 0;
        clearInterval(this.check)
      }
    },
    dingPush(row) {
      // 发送到后端或钉钉Webhook
      this.$httpajax.post('https://payment.javablade.com/api/robot/send', {
        tenant: 1,
        title: "Avue订单推送结果",
        list: [{
          label: "订单号",
          value: row.orderid
        }, {
          label: "用户QQ",
          value: row.qq
        }, {
          label: "套餐类型",
          value: row.$version,
        }, {
          label: "支付方式",
          value: row.$type
        }, {
          label: "授权名称",
          value: this.fpform.mc || '暂无'
        }, {
          label: "推送结果",
          value: "成功"
        }]
      })
    },
    refreshChange() {
      this.list = [];
      this.$message.success('刷新成功')
      this.getList();
    },
    getList(params) {
      if (this.validatenull(this.pwd)) return;
      if (this.user !== 'bladex') return;

      const query = new Record("x_order");
      query.auth(true);
      query.username(this.user);
      query.token(this.token);
      query.count().then(res => {
        this.page.total = res.data;
        const next = (this.page.currentPage - 1) * this.page.pageSize;
        query.limit(this.page.pageSize)
        query.skip(next)
        query.order("-datetime");
        for (let o in params) {
          query.equalTo(o, "=", `'${params[o]}'`);
        }
        return query.find()
      }).then(res => {
        const data = res.data;
        data.forEach(d => {
          d.datetime = new Date(d.datetime).Format("yyyy-MM-dd hh:mm:ss");
        })
        this.list = data;
      });
      this.getMoneyData();
    }
  }
}
</script>

<style lang="scss">
.payList {
  min-height: 700px;
}

input[type=number] {
  width: 35px !important;
}
</style>
